module.exports = __webpack_public_path__ + "img/sgc_logo_green.c20f29dd.png";